// extracted by mini-css-extract-plugin
module.exports = {"root":"Dropdown_root__hOYQF","dropdown":"Dropdown_dropdown___wna9","icon":"Dropdown_icon__l8OMf"};